export const exampleLog = store => next => action => {
    const result = next(action);
    const exampleActions = Object.keys(require('../constants/example.js'));

    if (exampleActions.includes(action.type)) {
        const { example } = store.getState();
        // eslint-disable-next-line no-console
        console.log('in middleware: ', example);
    }

    return result;
};
